// extracted by mini-css-extract-plugin
export default {"loading":"AssignFormsModal_loading__vmbu5"};